// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__RsRT8","title":"ClientCherryInfo_title__1qQBr","itemText":"ClientCherryInfo_itemText__3jasj"};